<template>
    <v-card class="pa-4" outlined>
        <v-form ref="form" class="d-flex align-center" style="width: 100%" v-model="valid">
            <div class="mb-3 mr-3">
                <v-text-field
                    v-model="fields.search"
                    @change="changed('search', $event)"
                    append-icon="mdi-magnify"
                    filled
                    label="Buscar"
                    hide-details
                    clearable
                ></v-text-field>
            </div>
            <div class="mb-3 mr-3">
                <SelectorDomain v-model="fields.domain_id" @change="changed('domain_id', $event)"/>
            </div>
            <div class="mb-3 mr-3">
                <SelectorState v-model="fields.state" @change="changed('state', $event)"/>
            </div>
        </v-form>
            <div class="d-flex">
                <v-spacer/>
                <v-btn text class="mr-3" :disabled="loading" @click="reset()">Reiniciar Filtros</v-btn>
                <v-btn color="primary" :disabled="loading" :loading="loading" @click="search()"><v-icon>mdi-magnify</v-icon>Buscar</v-btn>
            </div>
    </v-card>
</template>

<script>
import Search from '@mixins/search';

import MasterService from '@services/comercio/MasterService';
import ComercializadoraService from '@services/comercio/ComercializadoraService';
import GrupoService from '@services/comercio/GrupoService';

export default {
    props: ['value', 'loading'],
    mixins: [Search],
    data: function ()  {
        return {
            activeList: [
                {
                    text: 'Todos',
                    value: null,
                },
                {
                    text: 'Activos',
                    value: true,
                },
                {
                    text: 'Inactivos',
                    value: false,
                }
            ],

            defaultFields: {
                search: null,
                is_active: null,
                comercio_id: null,
                master_id: null,
                comercializadora_id: null,
                grupo_id: null,
                fecha: null,
            },

            isLoadingComerciosList: false,
            ComerciosList: [],

            isLoadingMasterList: false,
            masterList: [],

            isLoadingComercializadoraList: false,
            comercializadoraList: [],

            isLoadingGrupoList: false,
            grupoList: [],
           
        }
    },
    computed: {
        
    },
    created: function () {
        this.getMasterList();
    },
    methods: {
        getMasterList: function () {
            this.isLoadingMasterList = true;

            this.masterList = [];

            MasterService
                .getList({ is_active: true })
                .then(({ masterList }) => {
                    this.masterList = [{id: null, name: 'Todos'},...masterList];
                })
                .finally(() => this.isLoadingMasterList = false);
        },
        getComercializadoraList: function (params = {}) {
            this.comercializadoraList = [];

            this.isLoadingComercializadoraList = true;

            ComercializadoraService
                .getList({
                    ...{ is_active: true },
                    ...(this.fields.master_id ? {master_id: this.fields.master_id} : {}),
                    ...params
                })
                .then(({ comercializadoraList }) => { this.comercializadoraList = comercializadoraList; },)
                .finally(() => this.isLoadingComercializadoraList = false);
        },
        getGrupoList: function (params = {}) {
            this.grupoList = [];

            this.isLoadingGrupoList = true;

            GrupoService
                .getList({
                    ...{ is_active: true },
                    ...(this.fields.comercializadora_id ? {comercializadora_id: this.fields.comercializadora_id} : {}),
                    ...params
                })
                .then(({ grupoList }) => { this.grupoList = grupoList; },)
                .finally(() => this.isLoadingGrupoList = false);
        },
        onChange: function (field) {
            switch(field) {
                case 'master_id':
                    this.fields.comercializadora_id = null;   
                break;
                case 'comercializadora_id':
                    this.fields.grupo_id = null;
                break;
            }
        }
    },
    watch: {
        'fields.master_id': function () {
            this.getComercializadoraList();
        },
        'fields.comercializadora_id': function () {
            this.getGrupoList();
        },
        /*'fields.comercio_id': function (comercio_id) {
            if (juego_id !== null) {
                this.getJuegoSorteoList();
                this.getTipoJuegoSelected();
                this.fields.resultado = null;
            } else {
                this.juegoSorteoList = [];
                this.fields.resultado = null;
                this.fields.juego_sorteo_id = null;
            }
        },*/
    }
}
</script>

<style>

</style>